import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import './Login.css';
import consts from '../../../util/Consts'
import { Col, Container, Input, Row, Label, FormGroup } from 'reactstrap';
import { Formik, Form } from "formik";
import * as Yup from 'yup';
import Cookies from 'universal-cookie';
import { instance } from '../../../redux/actions/Index';
import api from '../../../redux/httpUtil/ServerApi';
import LoadingDialog from '../../../components/loadingDialog/LoadingDialog';
import PopupDialog from '../../../components/popupDialog/PopupDialog';
import './Login.css';

const cookies = new Cookies();

class Login extends PureComponent {
  constructor(props) {

    super(props);
    this.state = {
      token: '',
      isFetching: false
    }

    this.onLogin = this.onLogin.bind(this);
    sessionStorage.clear();
  }

  handleChange = (e, setFieldValue) => {
    this.setState({ loginError: false });
    setFieldValue(e.target.name, e.target.value);
  }

  onLogin = (values, { setSubmitting }) => {

    if (values.rememberMe) cookies.set('WebPoUserName', values.userName);
    cookies.set('WebPoRememberMe', values.rememberMe);

    this.setState({ isFetching: true }, ob => {

      instance.post(`${api.LOGIN}`, values)
        .then(res => {
          this.setState({ isFetching: false });
          setSubmitting(false);

          const { data } = res;
          const { data: Data, message, success } = data;

          if (success) {
            this.setState({ token: Data.token });
            Data.userName = values.userName;
            sessionStorage.setItem(consts.sessionVariables.UserData, JSON.stringify(Data));
            this.props.history.push("/PurchaseOrders");

          } else {

            this.setState({ loginError: message, showModal: true, popupMessage: message, popupTitle: "Login" }, () => {
              this.timeout = setTimeout(() => {
                this.setState({ showModal: false });
              }, 300000) // 5 min
            });
          }

        }).catch(err => {
          setSubmitting(false);
          this.setState({ isFetching: false });
          console.log(err);
        });

    });
  }

  popupSubmit = () => {
    this.setState({ showModal: false });
    clearInterval(this.timeout);
  }

  handleModal = () => {
    let showModal = this.state.showModal
    this.setState({ showModal: !showModal });
    if (showModal && this.timeout) clearInterval(this.timeout);
  }

  getInitialValues = () => {

    let WebPoRememberMe = cookies.get('WebPoRememberMe');
    WebPoRememberMe = WebPoRememberMe === "false" || WebPoRememberMe === "true" ? JSON.parse(WebPoRememberMe) : WebPoRememberMe;
    let WebPoUserName = cookies.get('WebPoUserName');

    return {
      userName: WebPoUserName && WebPoRememberMe ? WebPoUserName : '',
      password: '',
      rememberMe: WebPoRememberMe === false || WebPoRememberMe === true ? WebPoRememberMe : false
    }
  }

  render() {
    let { loginError, isFetching, popupTitle, showModal, popupMessage } = this.state;
    let initialValues = this.getInitialValues();

    return (
      <div className="login-wrapper">

        <LoadingDialog isOpen={isFetching}></LoadingDialog>
        <main role="main" >
          <Container className="login-container p-0">
            <Row className="gx-0">
              <Col lg="6" className="bg-white">
                <div className="login-box">
                  <div className="web-logo" >
                    <img src={require('./../../../assets/images/4warranty-log.png').default} alt="4Warranty" />
                  </div>

                  <h1 className={`login-title ${loginError ? 'mb-1' : 'mb-15'}`}>Login</h1>

                  <Formik
                    enableReinitialize={true}
                    initialValues={initialValues}
                    onSubmit={this.onLogin}
                    validationSchema={
                      Yup.object().shape({
                        userName: Yup.string().trim().required('Required'),
                        password: Yup.string().trim().required('Required'),
                      })
                    }
                  >
                    {function (props) {
                      const {
                        values,
                        errors,
                        isSubmitting,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        setFieldValue
                      } = props;
                      return (
                        <Form onSubmit={handleSubmit} className="form-login">

                          <div className="mb-1">
                            <Label className="block" for="Wusername">Username</Label>
                            <Input
                              value={values.userName}
                              onChange={(e) => this.handleChange(e, setFieldValue)}
                              onBlur={handleBlur}
                              id="Wusername"
                              type="text"
                              className="login-input"
                              name="userName"
                            />

                            {errors.userName ? <div className="input-error">{errors.userName}</div> : <div className="reqSubstitude"></div>}
                          </div>

                          <div className="mb-1">
                            <Label className="block" for="Wpassword">Password</Label>
                            <Input
                              type="password"
                              className="login-input"
                              name="password"
                              id="Wpassword"
                              autoComplete="new-password"
                              value={values.password}
                              onChange={(e) => this.handleChange(e, setFieldValue)}
                              onBlur={handleBlur}
                            />
                            {errors.password ? <div className="input-error">{errors.password}</div> : <div className="reqSubstitude"></div>}
                          </div>

                          <div className="mb-20">
                            <Input
                              type="checkbox"
                              className="login-input pointer"
                              name="rememberMe"
                              id="rememberMe"
                              placeholder="rememberMe"
                              checked={values.rememberMe}
                              value={values.rememberMe}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                            <Label className="rememberMeLabel" for="rememberMe">Remember me</Label>
                          </div>

                          <FormGroup className="mb-30">
                            <button disabled={isSubmitting} type="submit" className="btn-web"> Login </button>
                          </FormGroup>
                        </Form>

                      );
                    }.bind(this)}
                  </Formik>

                  <p className="copyright-text">Copyright &copy; Fortegra. All Rights Reserved.</p>
                </div>
              </Col>

              <Col lg="6" >
                <div className="login-thumb">
                  <img src={require('./../../../assets/images/login.jpg').default} alt="4Warranty" />
                </div>
              </Col>
            </Row>
          </Container>

          {showModal ? <PopupDialog
            showModal={showModal}
            handleModal={this.handleModal}
            title={popupTitle}
            message={popupMessage}
            popupSubmit={(val) => this.popupSubmit(val)}
          /> : ''}
        </main>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    token: state.token,
    login: state.login
  };
}

var LoginUser = connect(mapStateToProps)(Login);
export default LoginUser;